import React from 'react'
import PropTypes from 'prop-types'
import CloseButton from '../buttons/close-button'
import { lifecycle } from 'recompose'

const ModalWrapper = props => {
  return (
    <div className='overlay'>
      <div className='modal'>
        <CloseButton onClick={props.onClose} />
        <div className='modal-content'>{props.children}</div>
      </div>
    </div>
  )
}

ModalWrapper.propTypes = {
  onClose: PropTypes.func.isRequired
}

const preventScrollBehind = lifecycle({
  componentDidMount() {
    const root = document.documentElement
    if (root) {
      this._previousOverflowY = root.style.overflowY
      root.style.overflowY = 'hidden'
    }
  },
  componentWillUnmount() {
    const root = document.documentElement
    if (root) {
      root.style.overflowY = this._previousOverflowY || ''
    }
  }
})

export default preventScrollBehind(ModalWrapper)



// WEBPACK FOOTER //
// ./src/ui/modal/modal-wrapper.js